import { render, staticRenderFns } from "./helpDocument.vue?vue&type=template&id=40af2c0f&scoped=true"
import script from "./helpDocument.vue?vue&type=script&lang=js"
export * from "./helpDocument.vue?vue&type=script&lang=js"
import style0 from "./helpDocument.vue?vue&type=style&index=0&id=40af2c0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af2c0f",
  null
  
)

export default component.exports